import { useRef, useState } from "react";
import { Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const num = (v) => {
  const n = typeof v === "string" ? parseFloat(v.replace(",", ".")) : v;
  return Number.isFinite(n) ? n : 0;
};
export const blank = (v) => v === "" || v === undefined || v === null;
export const val = (v) => (blank(v) ? NaN : num(v));
export const str = (v) => String(v).replace(".", ",");
export const fmt = (v, d = 0) => (Number.isFinite(v) ? (Object.is(v, -0) ? 0 : v).toLocaleString("es-CR", { minimumFractionDigits: d, maximumFractionDigits: d }) : "—");

export const NumField = ({ id, label, value, onChange, suffix }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-xs text-[#5C635E]">{label}</Label>
    <div className="relative">
      <Input id={id} type="text" inputMode="decimal" autoComplete="off" value={value}
        onChange={(e) => onChange(e.target.value.replace(/[^0-9.,]/g, ""))}
        data-testid={`${id}-input`} className="bg-white pr-14" />
      {suffix && <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-[#5C635E]">{suffix}</span>}
    </div>
  </div>
);

export const Stat = ({ label, value, unit, testid, accent }) => (
  <div className={`p-5 ${accent ? "bg-[#1D3324] text-stone-100" : "bg-[#F3EAD7]/70"}`} data-testid={testid}>
    <p className={`text-xs uppercase tracking-wider ${accent ? "text-[#C5A059]" : "text-[#8B2B22]"}`}>{label}</p>
    <p className="f-display mt-2 text-3xl leading-none">{value}<span className="ml-1 text-sm font-sans opacity-70">{unit}</span></p>
  </div>
);

export const Note = ({ children }) => <p className="mt-6 text-xs text-[#5C635E] leading-relaxed">{children}</p>;

export const BrangusSwitch = ({ id, checked, onChange }) => (
  <label htmlFor={id} className="col-span-2 flex cursor-pointer items-center justify-between gap-4 border border-[#C5A059]/50 bg-[#F3EAD7]/60 px-4 py-3">
    <span>
      <span className="block text-sm font-semibold text-[#1D3324]">Incorporar genética Brangus</span>
      <span className="block text-xs text-[#5C635E]">Active para comparar con sus crías mejoradas con Brangus</span>
    </span>
    <Switch id={id} checked={checked} onCheckedChange={onChange} data-testid={`${id}-switch`} className="data-[state=checked]:bg-[#8B2B22]" />
  </label>
);

export const useResultsFocus = () => {
  const ref = useRef(null);
  const [flash, setFlash] = useState(0);
  const go = (e) => {
    e.preventDefault();
    setFlash((n) => n + 1);
    ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return { ref, flash, go };
};

export const CalcButton = ({ id }) => (
  <div className="col-span-2 space-y-2">
    <Button type="submit" data-testid={`${id}-calculate-button`} className="h-12 w-full rounded-full bg-[#8B2B22] text-base hover:bg-[#6f2019]">
      <Calculator size={18} className="mr-2" />Calcular resultados
    </Button>
    <p className="text-center text-xs text-[#5C635E]">Los resultados se actualizan al cambiar cualquier dato.</p>
  </div>
);
